import React from 'react';
import PaperClipIcon from './paper-clip';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function PaperclipIcon(props) {
  return ___EmotionJSX(PaperClipIcon, props);
}